import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ChangePassword } from "./ChangePassword";
import { Welcome } from "./Welcome";
import { ChangeEmail } from "./ChangeEmail";
import { ClaimAccount } from "./ClaimAccount";
import { Accepted } from "./Accepted";
import { PasswordSuccess } from "./PasswordSetupSuccess";
import { ChangePasswordSuccess } from "./ChangePasswordSuccess";
import { LeaderBoardIntro } from "./LeaderBoardIntro";
import { LeaderBoard } from "./LeaderBoard";
import { NotFound } from "./NotFound";
import { DeleteAccount } from "./DeleteAccount";
import { DeleteAccountSuccess } from "./DeleteAccountSuccess";
import { DeleteAccountData } from "./DeleteAccountData";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/reset-password" element={<ChangePassword />} />
        <Route path="/change-email" element={<ChangeEmail />} />
        <Route path="/claim-account" element={<ClaimAccount />} />
        <Route path="/accepted" element={<Accepted />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/password-success" element={<PasswordSuccess />} />
        <Route
          path="/change-password-success"
          element={<ChangePasswordSuccess />}
        />
        <Route path="/leaderboard-intro" element={<LeaderBoardIntro />} />
        <Route path="/leaderboard" element={<LeaderBoard />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/delete-account-data" element={<DeleteAccountData />} />
        <Route path="/delete-success" element={<DeleteAccountSuccess />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
